import type { SendingAnomalyItem } from '@repo/sdk/gen'
import type { BadgeVariant } from '@repo/ui/badge'
import type { TKey } from '@/lib/i18n'

type Kind = SendingAnomalyItem['kind']

const KINDS = [
	'transmission_not_delivered',
	'email_bounced',
	'ranking_failed',
	'offer_not_sent',
	'offer_bounced'
] as const satisfies readonly Kind[]

const KIND_LABEL = {
	transmission_not_delivered: 'admin-sending:kind.transmission_not_delivered',
	email_bounced: 'admin-sending:kind.email_bounced',
	ranking_failed: 'admin-sending:kind.ranking_failed',
	offer_not_sent: 'admin-sending:kind.offer_not_sent',
	offer_bounced: 'admin-sending:kind.offer_bounced'
} as const satisfies Record<Kind, TKey>

/** Red only for what is lost; orange for what needs a look soon. */
const KIND_TONE = {
	transmission_not_delivered: 'attention',
	email_bounced: 'warning',
	ranking_failed: 'destructive',
	offer_not_sent: 'destructive',
	offer_bounced: 'attention'
} as const satisfies Record<Kind, BadgeVariant>

export { KIND_LABEL, KIND_TONE, KINDS }
export type { Kind }
